export const JOB_CATEGORIES = [
  { id: 1, name: 'Executive senior level officials and managers' },
  { id: 2, name: 'First or mid-level officials and managers' },
  { id: 3, name: 'Professionals' },
  { id: 4, name: 'Technicians' },
  { id: 5, name: 'Sales workers' },
  { id: 6, name: 'Administrative support workers' },
  { id: 7, name: 'Craft workers' },
  { id: 8, name: 'Operatives' },
  { id: 9, name: 'Laborers and helpers' },
  { id: 10, name: 'Service workers' }
];
